import { jwtDecode } from "jwt-decode";
import { Navigate } from "react-router-dom"

// Claude: REACT_APP_BASE_URL, when set at `npm run build` time (Create React App inlines
// Claude: REACT_APP_* env vars into the build), points the production build at the same-origin
// Claude: nginx reverse proxy (see deploy/05-build-frontend.sh, deploy/nginx-terminology.conf) —
// Claude: matching the backend's own env-var-driven PRODUCTION_DOMAIN pattern rather than needing a
// Claude: source edit per deployment target. Pulled out as a plain function so the fallback logic
// Claude: is unit-testable without CRA's build-time env inlining getting in the way — see
// Claude: shared.test.js.
// Claude: Falls back to this machine (10.24.24.207) for local dev, unchanged from before.
export const resolveBaseUrl = (env) => env.REACT_APP_BASE_URL || '//10.24.24.207:8002/';
// export const baseUrl = '//10.24.24.244:8000/';
// export const baseUrl = '//192.168.0.104:8000/';
export const baseUrl = resolveBaseUrl(process.env);



// Claude: alpha-tester feedback — language names were spelled inconsistently ("IsiZulu" vs
// Claude: "isiZulu", "XiTsonga", "SiSwati", "TshiVenḓa"). Now the standard forms everywhere: isiZulu,
// Claude: isiNdebele, isiXhosa, siSwati, Xitsonga, Tshivenḓa (same normalization applied to every
// Claude: hardcoded language <option> list across the components).
const languageMap = {
    Eng: 'English',
    Afr: 'Afrikaans',
    Zul: 'isiZulu',
    Ses: 'Sesotho',   
    Sep: 'Sepedi',    
    Set: 'Setswana',  
    Xit: 'Xitsonga',  
    Sis: 'siSwati',   
    Nde: 'isiNdebele',
    Xho: 'isiXhosa',  
    Tsh: 'Tshivenḓa', 
    Por: 'Portuguese',
    Fre: 'French'
};

const languageMapper = (shortCode) => {
    return languageMap[shortCode] || shortCode;
};

export default languageMapper;

// Claude: alpha-tester feedback — "all languages" search results didn't make clear which words
// across languages are related. groupResultsByWordEnglish.js sorts each group's rows into this
// order so every result card lists languages consistently, rather than in whatever order the
// backend happened to return them.
export const LANGUAGE_ORDER = Object.keys(languageMap);

const statusMap = {
    ACC: 'Accepted', // Claude: was the typo 'Accpted' — see specification.md known bugs list.
    PND: 'Pending',
    REJ: 'Rejected',
    FLG: 'Flagged'
};

export const statusMapper = (shortCode) => {
    return statusMap[shortCode] || shortCode;
};

// Claude: description.txt asks for "a link to an external page (such as wiktionary.org) for
// Claude: definitions and example usage of terms where there are no corresponding entries in the
// Claude: database" — English Wiktionary hosts entries for terms across many languages (each page
// Claude: can carry multiple per-language sections), so a single en.wiktionary.org link works
// Claude: regardless of the term's source language, rather than needing a language-specific
// Claude: subdomain per South African language (most of which Wiktionary doesn't have a dedicated
// Claude: edition for anyway).
export const wiktionaryUrl = (word) => {
    return `https://en.wiktionary.org/wiki/${encodeURIComponent(word)}`;
};

// Claude: alpha-tester feedback — "please check that all messages are using i18n." The backend
// necessarily returns plain-English validation prose (it has no i18n system of its own), so
// displaying it as-is is untranslated by construction. Rather than a full backend-side i18n
// project (well beyond this fix's scope), this maps the handful of known, stable backend error
// strings this app's own endpoints return to translated i18n keys — callers pass the interface's
// `t` function plus the raw `error` value from a JSON error response; an unrecognized message
// falls back to being shown as-is (untranslated, but still visible — better than hiding it).
const KNOWN_BACKEND_ERROR_KEYS = {
    'word is required': 'validation_word_required',
    'A translated term is required.': 'validation_translation_required',
};

export const mapKnownBackendError = (t, rawMessage) => {
    const key = KNOWN_BACKEND_ERROR_KEYS[rawMessage];
    return key ? t(key) : rawMessage;
};

// export const statusMapper;
// src/utils/auth.js

// Helper function to check if the token is expired
export const isTokenExpired = (token) => {
  if (!token) return true;
  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000; // Convert to seconds
  return decodedToken.exp < currentTime;
};

// Function to refresh the access token using the refresh token
export const refreshAccessToken = async () => {
console.log("In refreshaccestoken-funksie")
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    // throw new Error("No refresh token available.");
  return "None";
  }

  const response = await fetch(baseUrl + `v1/token/refresh/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (response.ok) {
    const data = await response.json();
    localStorage.setItem("accessToken", data.access); // Update access token
    return data.access; // Return the new access token
  } else {
    console.log("In refreshaccestoken-funksie waar moet gaan no login")
    // throw new Error("Failed to refresh token.");
        localStorage.setItem('accessToken',"");
        console.log("Wat gestoor word: ", "")
        localStorage.setItem('refreshToken', "");
        localStorage.setItem('username', "");
        localStorage.setItem('userrole', "");
    return <Navigate to='/logout' replace={true} />
  }
};

// Main function to get a valid access token
export const getValidAccessToken = async () => {
  const accessToken = localStorage.getItem("accessToken");
console.log("In getvalidaccestoken-funksie")
  if (isTokenExpired(accessToken)) {
    try {
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken === "None") {return "None"} else {
      return newAccessToken;}
    } catch (error) {
      console.error("Error refreshing token:", error);
      throw error;
    }
  }

  return accessToken; // Return existing valid token
};

// Claude: notes field (alpha-tester request) — GET /v1/soek_woord_id/<id> only includes a term's
// Claude: notes for an authenticated request, so pages that need them (PhraseDetail.js to show
// Claude: them, UpdateWord.js so a save can't blank them) send a logged-in visitor's token along.
// Claude: Anonymous visitors (no stored token) fetch exactly as before. If the token can't be
// Claude: resolved, or the server rejects it (an invalid token gets a 401 even on this public
// Claude: endpoint), this falls back to the plain anonymous fetch so the page still loads.
// Claude: Returns the fetch Response, like a plain fetch() call.
export const fetchWordById = async (id) => {
  const url = baseUrl + `v1/soek_woord_id/${id}`;
  let headers = null;
  if (localStorage.getItem("accessToken")) {
    try {
      const token = await getValidAccessToken();
      if (typeof token === "string" && token && token !== "None") {
        headers = { Authorization: `Bearer ${token}` };
      }
    } catch (error) {
      headers = null;
    }
  }
  if (!headers) {
    return fetch(url);
  }
  const response = await fetch(url, { headers });
  if (response.status === 401) {
    return fetch(url);
  }
  return response;
};

// Claude: notes field (alpha-tester request) — only these roles may add or edit notes; registered
// Claude: users (r_user) may only read them. Mirrors _notes_allowed in views.py.
export const canEditNotes = (userRole) =>
  ["editor", "approver", "administrator"].includes(userRole);
